/**
 * Created by roman.kupin on 9/28/2017.
 */

import * as AccountApiActions from "../../actions/accountApi";


export default function randomPhotosReducer(state = [], {type, payload}) {
    switch (type) {
        case AccountApiActions.RANDOM_PHOTOS_FETCH_SUCCESS: {
            return payload;
        }
        default: {
            return state;
        }
    }
}